"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _callFunc = _interopRequireDefault(require("call-func"));
var HasMap = function HasMap(o, k) {
  var _ref;
  return (_ref = o && o.size && (0, _callFunc["default"])(o.has, [k], o)) !== null && _ref !== void 0 ? _ref : (0, _reshowConstant.HAS)(o, k);
};
var _default = exports["default"] = HasMap;
module.exports = exports.default;